import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { XeroRegistration } from './XeroRegistration';
import { XeroRegistrationFooter } from './XeroRegistrationFooter';
import { XeroRegisterFormSchema, type XeroRegisterFormValues } from './XeroRegisterFormSchema';

export const RegisterToXeroComponents: FormDrawerProps<ZodSchema<XeroRegisterFormValues>> = {
  zodSchema: XeroRegisterFormSchema,
  ContentComponent: XeroRegistration,
  Footer: XeroRegistrationFooter,
};
